import { createApi } from "@reduxjs/toolkit/query/react";

import { tomService } from "./restService";

export const benefitsPlanApi = createApi({
  reducerPath: "benefitsPlanApi",
  baseQuery: tomService({
    baseUrl: `${process.env.REACT_APP_BASE_URL}`,
  }),
  tagTypes: ["BenefitsPlan", "BenefitsPlanVersions"],
  endpoints: builder => ({
    fetchBenefitsPlans: builder.query({
      query: ({
        company_id,
        page = 1,
        page_size,
        sort_by,
        order,
        search,
      }) => ({
        url: `/company/${company_id}/benefit-plans/?page=${page}&page_size=${page_size}${sort_by ? `&sort_by=${sort_by}` : ""
          }${order ? `&order=${order}` : ""}${search ? `&search=${encodeURIComponent(search)}` : ""
          }`,
        method: "GET",
      }),
      providesTags: ["BenefitsPlan"],
    }),
    // fetchBenefitsPlans: builder.query({
    //   query: ({ company_id, page = 1, page_size }) => ({
    //     url: `/company/${company_id}/benefit-plans/?page=${page}&page_size=${page_size}`,
    //     method: "GET",
    //   }),
    //   providesTags: ["BenefitsPlan"],
    // }),
    fetchBenefitPlanTypes: builder.query({
      query: () => ({
        url: `/benefit-plan-types/`,
        method: "GET",
      }),
    }),
    fetchBenefitsPlanVersions: builder.query({
      query: ({ company_id, page = 1, page_size = 10 }) => ({
        url: `/company/${company_id}/benefit-plans-versions/?page=${page}&page_size=${page_size}`,
        method: "GET",
      }),
      providesTags: ["BenefitsPlanVersions"],
    }),

    createBenefitsPlan: builder.mutation({
      query: ({ body, company_id }) => ({
        url: `/company/${company_id}/benefit-plans/create/`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["BenefitsPlan"],
    }),
    deleteBenefitsPlan: builder.mutation({
      query: ({ id, company_id }) => ({
        url: `/company/${company_id}/benefit-plans/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["BenefitsPlan"],
    }),
    updateBenefitsPlan: builder.mutation({
      query: ({ id, company_id, body }) => ({
        url: `/company/${company_id}/benefit-plans/${id}/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["BenefitsPlan"],
    }),
    updateBenefitsPlanVersion: builder.mutation({
      query: ({ company_id, version_id }) => ({
        url: `/company/${company_id}/benefit-plans-versions/${version_id}/set-active/`,
        method: "PATCH",
      }),
      invalidatesTags: ["BenefitsPlan","BenefitsPlanVersions"],
    }),
    uploadBenefitsPlan: builder.mutation({
      query: ({ company_id, active, body }) => ({
        url: `/company/${company_id}/benefits-plan/upload/?active=${active}`,
        method: "POST",
        body,
        formData: true,
      }),
      invalidatesTags: ["BenefitsPlan", "BenefitsPlanVersions"],
    }),
    downloadBenefitsPlans: builder.query({
      query: ({ company_id, version_id }) => ({
        url: `/company/${company_id}/benefits-plan/download/${version_id ? `?version_id=${version_id}` : ""
          }`,
        method: "GET",
      }),
    }),

    fetchEmployeeTypeRanges: builder.query({
      query: ({ company_id }) => ({
        url: `/company/${company_id}/employee-type-ranges/`,
        method: "GET",
      }),
    }),
  }),
});
export const {
  useFetchBenefitsPlansQuery,
  useFetchBenefitPlanTypesQuery,
  useCreateBenefitsPlanMutation,
  useDeleteBenefitsPlanMutation,
  useUpdateBenefitsPlanMutation,
  useFetchBenefitsPlanVersionsQuery,
  useUpdateBenefitsPlanVersionMutation,
  useUploadBenefitsPlanMutation,
  useDownloadBenefitsPlansQuery,
  useFetchEmployeeTypeRangesQuery
} = benefitsPlanApi;
